// removed by extract-text-webpack-plugin
module.exports = {"root":"_2k8PF","content":"z_3mN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/AppRenderer.css
// module id = 495
// module chunks = 3